import type { CatalogItem, FulfillmentMode, ListingDraft, MarketplaceCode } from "./types";

export function getBlockedFulfillmentModes(
  offers: CatalogItem["existingOffers"],
  targetMarketplaces: MarketplaceCode[],
): FulfillmentMode[] {
  return [...new Set(
    (offers ?? [])
      .filter((offer) => targetMarketplaces.includes(offer.marketplace))
      .map((offer) => offer.fulfillmentMode),
  )];
}

export function getCatalogSelectionDraft(
  draft: ListingDraft,
  item: CatalogItem,
): ListingDraft | null {
  // Catalog selection starts from Amazon DE; later validation uses actual targets.
  const blocked = getBlockedFulfillmentModes(item.existingOffers, ["DE"]);
  if (blocked.includes("FBM") && blocked.includes("FBA")) return null;
  const fulfillmentMode = blocked.includes(draft.fulfillmentMode)
    ? draft.fulfillmentMode === "FBM" ? "FBA" : "FBM"
    : draft.fulfillmentMode;

  return {
    ...draft,
    asin: item.asin,
    productType: item.productType,
    attributes: {},
    fulfillmentMode,
    ...(fulfillmentMode === "FBA"
      ? {
          targetMarketplaces: ["DE"] as MarketplaceCode[],
          startPrices: typeof draft.startPrices.DE === "number" ? { DE: draft.startPrices.DE } : {},
          shippingTemplates: {},
        }
      : {}),
  };
}

export function getDuplicateOfferError(
  draft: ListingDraft,
  item: CatalogItem | null,
): string | null {
  if (draft.mode !== "MATCH_EXISTING_ASIN" || !item || item.asin !== draft.asin) return null;
  const conflicts = (item.existingOffers ?? []).filter(
    (offer) => offer.fulfillmentMode === draft.fulfillmentMode &&
      draft.targetMarketplaces.includes(offer.marketplace),
  );
  if (!conflicts.length) return null;
  const marketplaces = [...new Set(conflicts.map((offer) => offer.marketplace))].join(", ");
  return `Für diese ASIN besteht bereits ein eigenes ${draft.fulfillmentMode}-Angebot auf Amazon ${marketplaces}. Ein weiteres ${draft.fulfillmentMode}-Angebot kann dort nicht angelegt werden. Bitte wähle einen noch nicht vorhandenen Versandweg.`;
}
